import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleRedio, SingleText, SingleInput } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space, EditButton } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { getval2Token } from '../../../../Login/Auth';
import { api_addUmpire, api_getUmpireDetail, api_checkUmpireName } from '../../../../../api/MyStat/apiUmpire';
import { ReqUmpireDetail, RespUmpire } from '../../../../../item/MyStat/ItemUmpire';
import { UploadPhoto } from '../UploadPhoto';
import { get_activation_string, activation_Items } from '../../../../../item/MyStat/ItemMyStatBase';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';


export function UMPEdit({ id, setIsLoading, isEdit, isAdd = false }) {
  const [tokenId, setTokenId] = useState("")

  const [_id, set_id] = useState("")
  const [ump_id, set_ump_id] = useState("")
  const [ump_name, set_ump_name] = useState("")
  const [ump_name_eng, set_ump_name_eng] = useState("")
  const [ump_DOB, set_ump_DOB] = useState("")
  const [ump_activation, set_ump_activation] = useState(1)
  const [ump_last_change, set_ump_last_change] = useState("")
  const [ump_note, set_ump_note] = useState("")

  const [ump_pic_profile, set_ump_pic_profile] = useState("")
  const [ump_pic_profile_auth, set_ump_pic_profile_auth] = useState(0)
  const [ump_pic_profile_date, set_ump_pic_profile_date] = useState("")

  const [ump_pic_game, set_ump_pic_game] = useState("")
  const [ump_pic_game_auth, set_ump_pic_game_auth] = useState(0)
  const [ump_pic_game_date, set_ump_pic_game_date] = useState("")

  const [isCheckRepeat, setCheckRepeat] = useState(false)
  const [isRepeat, setRepeat] = useState(false)
  const [repeatMessage, setRepeatMessage] = useState("")

  const [birthError, setBirthError] = useState(false)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("UMPEdit", id)
      console.log(obj)
      set_ump_id(obj.ump_id)
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (ump_id !== undefined && ump_id !== "") {
      // setIsLoading(true)
      var mReqUmpireDetail = new ReqUmpireDetail({
        ump_id
      })
      getDetail(mReqUmpireDetail)
    }
  }, [ump_id])

  function getDetail(mReqUmpireDetail) {
    console.log(mReqUmpireDetail)
    setIsLoading(true)
    api_getUmpireDetail({
      mReqUmpireDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespUmpire = new RespUmpire({})
        mRespUmpire.fromJson(jsonData.detail)

        set_id(mRespUmpire._id)
        set_ump_name(mRespUmpire.ump_name)
        set_ump_name_eng(mRespUmpire.ump_name_eng)
        set_ump_DOB(moment(mRespUmpire.ump_DOB).format('YYYY-MM-DD'))
        set_ump_activation(mRespUmpire.ump_activation)
        set_ump_last_change(moment(mRespUmpire.ump_last_change).format('YYYY-MM-DD'))
        set_ump_note(mRespUmpire.ump_note)
        set_ump_pic_profile(mRespUmpire.ump_pic_profile)
        set_ump_pic_profile_auth(mRespUmpire.ump_pic_profile_auth)
        
        var pic_profile_date = moment(mRespUmpire.ump_pic_profile_date).format('YYYY-MM-DD HH:mm:ss')
        if (pic_profile_date === "Invalid date")
          pic_profile_date = ""
        set_ump_pic_profile_date(pic_profile_date)

        set_ump_pic_game(mRespUmpire.ump_pic_game)
        set_ump_pic_game_auth(mRespUmpire.ump_pic_game_auth)

        var pic_game_date = moment(mRespUmpire.pic_game_date).format('YYYY-MM-DD HH:mm:ss')
        if (pic_game_date === "Invalid date")
          pic_game_date = ""
        set_ump_pic_game_date(pic_game_date)

        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }


  function checkName(val) {
    setIsLoading(true)
    var mRespUmpire = new RespUmpire({
      ump_name: val,
    })
    console.log(mRespUmpire)
    api_checkUmpireName({
      mRespUmpire,
      success: (jsonData) => {
        console.log(jsonData)
        setIsLoading(false)
        setCheckRepeat(true)
        if (jsonData.id === "") {
          setRepeat(false)
          setRepeatMessage("此主審名稱無重覆")
        } else {
          setRepeat(true)
          setRepeatMessage("與主審編號" + jsonData.id + "同名")
        }
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function toEdit() {
    window.location.assign("/UMP_Edit/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  const onChange = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setBirthError(true)
    } else {
      setBirthError(false)
      set_ump_DOB(dateString)
    }
  }

  function toAdd() {
    // console.log(ump_type)
    var inputError = []
    if (ump_name === "") {
      inputError.push("中文名字")
    }
    if (ump_DOB === "") {
      inputError.push("出生年月日")
    }

    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }

    setIsLoading(true)
    var mRespUmpire = new RespUmpire({
      ump_id,
      ump_name,
      ump_name_eng,
      ump_DOB: moment(ump_DOB).format('YYYY-MM-DD'),
      ump_activation,
      ump_last_change,
      ump_note,
      ump_pic_profile,
      ump_pic_profile_auth,
      ump_pic_profile_date,
      ump_pic_game,
      ump_pic_game_auth,
      ump_pic_game_date
    })

    console.log(mRespUmpire)
    api_addUmpire({
      isAdd,
      mRespUmpire,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = "主審" + (isAdd ? "新增" : isEdit ? "編輯" : "檢視")
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">

          <div className="col-md-6">
            <UploadPhoto
              title={"主審照片"}
              Photo={ump_pic_profile}
              PhotoAuth={ump_pic_profile_auth}
              PhotoDate={ump_pic_profile_date}
              setIsLoading={setIsLoading}
              set_Photo={set_ump_pic_profile}
              set_PhotoAuth={set_ump_pic_profile_auth}
              set_PhotoDate={set_ump_pic_profile_date}
              isEdit={isEdit}
            />

            <UploadPhoto
              title={"主審背景"}
              Photo={ump_pic_game}
              PhotoAuth={ump_pic_game_auth}
              PhotoDate={ump_pic_game_date}
              setIsLoading={setIsLoading}
              set_Photo={set_ump_pic_game}
              set_PhotoAuth={set_ump_pic_game_auth}
              set_PhotoDate={set_ump_pic_game_date}
              isEdit={isEdit}
            />
          </div>

          <div className="col-md-6">
            <div className="row">
              {isEdit ?
                <SingleInput title={"中文名稱"} val={ump_name} action={set_ump_name} action_blur={checkName} placeholder={""} size={8} />
                : <SingleText title={"中文名稱"} val={ump_name} size={8} />
              }

              {isEdit ?
                <div class="col-md-4">
                  <p>出生年月日</p>
                  <DatePickerInput
                    displayFormat='YYYY/MM/DD'
                    returnFormat='YYYY-MM-DD'
                    onChange={onChange}
                    value={ump_DOB}
                    className='my-react-component'
                    showOnInputClick={true}
                  />
                </div>
                : <SingleText title={"出生年月日"} val={ump_DOB} size={4} />
              }
            </div>
            {isCheckRepeat ?
              <div className="row">
                <div className="col-md-4">
                  <p className={isRepeat ? "text-danger" : "text-info"}>{repeatMessage}</p>
                </div>
              </div>
              : <></>}
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="row">
              {isEdit ?
                <SingleInput title={"英文名稱"} val={ump_name_eng} action={set_ump_name_eng} placeholder={""} size={8} />
                : <SingleText title={"英文名稱"} val={ump_name_eng} size={8} />
              }
              {isAdd ?
                <></>
                : <SingleText title={"編號"} val={_id} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="row">
              {
                isEdit ?
                  <SingleRedio title={"啟停用"}
                    arr={activation_Items}
                    val={ump_activation ? 1 : 0}
                    action={set_ump_activation}
                    size={4}
                  />
                  :
                  <SingleText title={"啟停用"}
                    val={get_activation_string(ump_activation)}
                    size={4} />
              }
              {isAdd ?
                <></>
                : <SingleText title={"異動日期"} val={ump_last_change} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="row">
              {isEdit ?
                <SingleInput title={"註記"} val={ump_note} action={set_ump_note} placeholder={"內部人員註記"} size={12} />
                : <SingleText title={"註記"} val={ump_note} size={12} />
              }
            </div>
          </div>



        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="row">
        {
          isAdd || isEdit ?
            <div className="col-sm-3 col-sm-offset-9">
              <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
            </div>
            :
            <EditButton action={toEdit} isRight={true} />
        }
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={false} />
      <SystemPromptInput />
    </>
  )
}